'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('lodash/fp/curry');

var _curry2 = _interopRequireDefault(_curry);

var _prop = require('lodash/fp/prop');

var _prop2 = _interopRequireDefault(_prop);

var _map = require('./map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * mapProp :: string -> Just a -> Just b
 * @param {String} propName
 * @param {Just} just - container
 * @return {Just}
  * */
var mapProp = (0, _curry2.default)(function (propName, just) {
  return (0, _map2.default)((0, _prop2.default)(propName), just);
});

exports.default = mapProp;